// removed by extract-text-webpack-plugin
module.exports = {"links":"footer-38O","icon":"footer-2n4","link-list":"footer-3Y3","link-wrapper":"footer-34Z"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/Footer/Links/links.module.scss
// module id = 297
// module chunks = 0